module.exports = __webpack_public_path__ + "static/img/b2682192-9ccf-419d-a217-76118f6b7a71.30a9ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/b2682192-9ccf-419d-a217-76118f6b7a71.png
// module id = 1TCu
// module chunks = 0